import { RegionShared } from "@1games-ru/region-shared";
import { EstateComplexLevel } from "@1games-ru/region-shared/dist/enums/estate/estate";
import { useCallback, useLayoutEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import rpc from "@1games-ru/rage-rpc";
import EstateMpProvider from "@/core/data-provider/data-mp/estate/estate-mp-provider";
import { RpcMpProviderFailedResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-failed-response";
import toast from "@/domains/toasts/helpers/toast";

export default () => {
  const { t } = useTranslation("estate");
  const [show, setShow] = useState(false);
  const [estateComplexSectionId, setEstateComplexSectionId] = useState<number | null>(null);
  const [currentFloor, setCurrentFloor] = useState<number | null>(null);
  const [floors, setFloors] = useState<number[]>([]);
  const [level, setLevel] = useState<EstateComplexLevel | null>(null);

  const floorTransit = useCallback(
    async (targetFloor) => {
      if (targetFloor === 1 && currentFloor === 1) {
        return;
      }

      let response;

      if (targetFloor === 1) {
        response = await EstateMpProvider.streetFromFloorTransit();
      } else {
        response = await EstateMpProvider.floorTransit(estateComplexSectionId, targetFloor);
      }

      if (response instanceof RpcMpProviderFailedResponse) {
        toast.error(t(`estate.errors.${response.error.message}`));
        return;
      }

      setCurrentFloor(targetFloor);
    },
    [t, estateComplexSectionId, setCurrentFloor],
  );

  useLayoutEffect(() => {
    rpc.register(
      RegionShared.Cef.Events.Estate.EstateComplexElevatorShow,
      async (
        state: typeof RegionShared.Cef.Requests.EstateComplexElevatorShowRequest,
      ): Promise<void> => {
        setShow(true);
        setFloors(state.floors);
        setEstateComplexSectionId(state.estateComplexSectionId);
        setCurrentFloor(state.currentFloor);
        setLevel(state.level);
      },
    );

    rpc.register(
      RegionShared.Cef.Events.Estate.EstateComplexElevatorHide,
      async (): Promise<void> => {
        setShow(false);
        setEstateComplexSectionId(null);
        setFloors([]);
      },
    );

    return () => {
      rpc.unregister(RegionShared.Cef.Events.Estate.EstateComplexElevatorShow);
      rpc.unregister(RegionShared.Cef.Events.Estate.EstateComplexElevatorHide);
    };
  }, []);

  return {
    show,
    currentFloor,
    level,
    floors,
    floorTransit,
  };
};
